import { render, staticRenderFns } from "./ApprovalDumbapp.vue?vue&type=template&id=6b5b9c72&scoped=true&"
import script from "./ApprovalDumbapp.vue?vue&type=script&lang=ts&"
export * from "./ApprovalDumbapp.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalDumbapp.vue?vue&type=style&index=0&id=6b5b9c72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b9c72",
  null
  
)

export default component.exports